export const rankings = [
  { rank: 1, title: '星屑彼端的旅人', genre: '奇幻 / 冒险', score: 9.1, trend: 'up' },
  { rank: 2, title: '妖精庭院物语', genre: '奇幻 / 治愈', score: 9.0, trend: 'up' },
  { rank: 3, title: '雾之都侦探社', genre: '悬疑 / 奇幻', score: 8.9, trend: 'same' },
  { rank: 4, title: '黄昏列车终点站', genre: '深夜档 / 悬疑', score: 8.8, trend: 'up' },
  { rank: 5, title: '机械心脏与春日约定', genre: '科幻 / 治愈', score: 8.7, trend: 'down' },
  { rank: 6, title: '苍蓝食堂的午后', genre: '治愈 / 日常', score: 8.6, trend: 'same' },
  { rank: 7, title: '幻夜书房奇谭', genre: '奇幻 / 悬疑', score: 8.5, trend: 'up' },
  { rank: 8, title: '夏日回声日记', genre: '日常 / 校园', score: 8.4, trend: 'down' },
];